var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "summary-item-background noselect"
  }, [_c('div', {
    staticClass: "div-column"
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _c('span', {
    staticClass: "bl-color bold"
  }, [_vm._v(_vm._s(_vm.value))])]), _vm.value ? _c('clipboard-button', {
    attrs: {
      "value": _vm.value
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }